import { Component, Output, EventEmitter, Input } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { DevelopmentHelpers } from 'app/shared/utilities/developHelpers';
import * as api from '../../shared/api/apihandler';

@Component({
  selector: 'app-fileupload',
  templateUrl: './fileupload.component.html',
  styleUrls: ['./fileupload.component.css']
})

export class FileuploadComponent {
  constructor(private httpClient: HttpClient) {}

  help = new DevelopmentHelpers();
  id = this.help.guid.newGUID();
  fileName = "";
  @Input() specificFileType;
  @Output() fileId: EventEmitter<any> = new EventEmitter();

  addFile(e): void {
    if (!!e && e.length > 0) {
      let name = e[0].type.split('/');
      if (!!this.specificFileType && this.specificFileType != name[name.length-1]) {
        console.log('wrong filetype added');
      } else {
        this.upload(e[0]).subscribe(res => { this.fileId.emit(res); });
      }
    }
  }

  upload(fileToUpload: any) {
    let input = new FormData();
    input.append("file", fileToUpload);
    return this.httpClient.post(api.jubloApi + 'api/shared/attachments/file', input);
  }
}
